import { ArrowPathIcon, HomeIcon } from '@heroicons/react/24/outline';
import React from 'react';

import applicationVersion from '../../../../application_version.txt';

interface SentryErrorFallbackProps {
  error?: unknown;
  componentStack?: string;
  resetError?: () => void;
}

function SentryErrorFallback({ error, componentStack, resetError }: SentryErrorFallbackProps) {
  return (
    <div className="flex items-center justify-center px-4 py-4 sm:px-6 lg:px-12">
      <div className="w-full max-w-3xl space-y-8 rounded-xl bg-white p-12 shadow-2xl">
        <div className="grid place-content-center">
          <img alt="Déclarations Juridiques Logo" src={require('../../../img/logo.svg')} className="mx-auto w-96" />
        </div>
        <div className="text-center">
          <h2 className="mt-6 text-4xl font-extrabold text-gray-900">Erreur</h2>
          <p className="mt-2 text-lg text-gray-600">Une erreur inattendue s'est produite.</p>
        </div>
        <div className="mt-10 space-y-5 px-4 text-center sm:px-6 lg:px-12">
          <div className="flex items-center justify-between">
            {resetError && (
              <button
                onClick={resetError}
                className="group hover:bg-gray-80 relative flex w-full justify-center rounded-xl border border-transparent bg-gray-50 px-6 py-3 text-lg font-medium text-rgpd-blue focus:ring-2 focus:ring-offset-2 focus:outline-none"
              >
                <span className="absolute inset-y-0 left-0 flex items-center pl-3">
                  <ArrowPathIcon className="h-6 w-6 text-rgpd-blue" aria-hidden="true" />
                </span>
                Réessayer
              </button>
            )}
          </div>
          <a
            href="/"
            className="group relative flex w-full justify-center rounded-xl border border-transparent bg-rgpd-blue px-6 py-3 text-lg font-medium text-rgpd-white hover:bg-rgpd-blue-dark focus:ring-2 focus:ring-offset-2 focus:outline-none"
          >
            <span className="absolute inset-y-0 left-0 flex items-center pl-3">
              <HomeIcon className="h-6 w-6 text-rgpd-white" aria-hidden="true" />
            </span>
            Retour à l'accueil
          </a>
        </div>
        <div className="mt-10">
          {applicationVersion && (applicationVersion == 'v0.0.0' || applicationVersion == 'dev') && (
            <div className="-space-y-px rounded-xl shadow-sm">
              <div className="bg-gray-50 px-6 py-6 sm:p-8">
                <h3 className="text-xl leading-6 font-medium text-gray-900">
                  Détails de l'erreur
                </h3>
                <div className="mt-4 max-w-xl text-base text-gray-500">
                  <p className="font-semibold">{error != null ? String(error) : 'Erreur inconnue'}</p>
                  {componentStack && <pre className="mt-2 whitespace-pre-wrap">{componentStack}</pre>}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default SentryErrorFallback;
